import {IRestriction} from './IRestriction';
import {ObbBuilder} from '../../../../collision/obb-builder.service';
import {IPost} from '../../../object3D';

declare const THREE: any;

type postSelector = (obj) => boolean;

export class CollisionRestriction implements IRestriction {

  private children: any[];
  private postsSelector: postSelector;

  constructor(children: any[], postsSelector: postSelector) {
    this.children = children;
    this.postsSelector = postsSelector;
  }

  check(post: IPost, newPosition, edge: Feeney.IEdge): boolean {

    const draggedPostOBB = new ObbBuilder()
      .setPosition(newPosition.clone().setY(0))
      .setSize(new THREE.Vector3(post.getSize(), 0, post.getSize()))
      .build(post);

    const otherPostsOBB = this.children.filter(this.postsSelector).map(p =>
      new ObbBuilder()
        .setPosition(p.position.clone().setY(0))
        .setSize(new THREE.Vector3(p.getSize(), 0, p.getSize()))
        .build(p)
    );

    return otherPostsOBB.find(obb => obb.isIntersectionOBB(draggedPostOBB)) === undefined;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/components/MoveObjectComponent/MovePostRestrictions/CollisionRestriction.ts